import React from 'react';
import { Tabs, Card } from 'antd';
import * as S from './TabCard.styles';

interface Tab {
  key: string;
  title: string;
  content: React.ReactNode;
}

interface TabCardProps {
  tabs: Tab[];
  defaultActiveKey?: string;
  activeKey?: string;
  onChange?: (key: string) => void;
  title?: React.ReactNode;
}

export const TabCard: React.FC<TabCardProps> = ({ tabs, defaultActiveKey = '0', activeKey, onChange, title }) => {
  return (
    <S.StyledCard title={title}>
      <Tabs defaultActiveKey={defaultActiveKey} activeKey={activeKey} onChange={onChange}>
        {tabs.map((tab) => (
          <Tabs.TabPane tab={tab.title} key={tab.key}>
            {tab.content}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </S.StyledCard>
  );
};
